const System = () => import('./views/index.vue');

export default [
  {
    name: 'system',
    path: '/system',
    component: System,
    meta: { title: '预览' }
  }
];
